import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  savedMessagesKey,
  savedMessagesRoute,
  errorMessage,
  savedNotesKey,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';

type UseCreateSavedMessageProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useCreateSavedMessage = ({
  setErrorText,
}: UseCreateSavedMessageProps) => {
  const client = useQueryClient();

  const { mutate: createSavedMessage, isLoading: isCreatingSavedMessage } =
    useMutation({
      mutationFn: (variables: { label: string; content: string,is_note?:boolean }) =>
        axiosInstance
          .post(savedMessagesRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([savedMessagesKey]);
          client.invalidateQueries([savedNotesKey]);
        }
      },
      onError: (error: { message?: string }) => {
        setErrorText(error?.message || errorMessage);
      },
    });

  return {
    createSavedMessage,
    isCreatingSavedMessage,
  };
};
